<template>
  <div id="main-listado-contrato-inventario">
    <desktop desktop :listadoInventarios="listadoInventarios" />
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoContratoInventario',
  components: {
    Desktop,
  },
  props: {
    listadoInventarios: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
